import React from 'react';
import { I18n } from 'aws-amplify';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { AmplifyUser } from '@aws-amplify/ui';
import { UseAuthenticator } from '@aws-amplify/ui-react-core';
import './custom-authenticator.scss';
import Header from 'components/header';

export type SignOut = UseAuthenticator['signOut'];

I18n.putVocabulariesForLanguage('en', {
  'Sign in': 'Log in',
  'Create Account': 'Agree and join'
});

const formFields = {
  signIn: {
    username: {
      placeholder: 'Email',
      isRequired: true,
      label: ''
    },
    password: {
      placeholder: 'Password',
      isRequired: true,
      label: ''
    }
  },
  signUp: {
    'custom:company_name': {
      label: '',
      placeholder: 'Company Name',
      isRequired: true,
      order: 1
    },
    given_name: {
      label: '',
      placeholder: 'First Name',
      isRequired: true,
      order: 2
    },
    family_name: {
      label: '',
      placeholder: 'Last Name',
      isRequired: true,
      order: 2
    },
    email: {
      label: '',
      placeholder: 'Work email',
      isRequired: true,
      order: 3
    },
    password: {
      placeholder: 'Password',
      isRequired: true,
      label: '',
      order: 4
    },
    confirm_password: {
      label: '',
      order: 5
    }
  }
};

interface CustomAuthenticatorParams {
  children: React.ReactNode | ((props: { signOut?: SignOut; user?: AmplifyUser }) => JSX.Element);
}

function CustomAuthenticator({ children }: CustomAuthenticatorParams): JSX.Element {
  return (
    <Authenticator
      initialState="signUp"
      loginMechanisms={['email']}
      formFields={formFields}
      components={{
        Header() {
          return <Header />;
        },
        SignIn: {
          Header() {
            return (
              <div className="header-container">
                <div className="header">Log in</div>
              </div>
            );
          },
          Footer() {
            const { toResetPassword, toSignUp } = useAuthenticator();

            return (
              <div className="footer text-sm text-gray-700">
                <div>
                  Need an account?&nbsp;
                  <a className="cursor-pointer btn-link" onClick={toSignUp}>
                    Join now
                  </a>
                </div>
                <div>
                  Forgot your password?&nbsp;
                  <a className="cursor-pointer btn-link" onClick={toResetPassword}>
                    Reset Password
                  </a>
                </div>
              </div>
            );
          }
        },
        SignUp: {
          Header() {
            return (
              <div className="header-container">
                <div className="header">Create an account for your company</div>
                <div className="sub-header">
                  You’re a few steps away from finishing your CA Pay Data Reports
                </div>
              </div>
            );
          },
          FormFields() {
            return (
              <>
                <Authenticator.SignUp.FormFields />
                <div className="text-sm text-gray-700 mb-4">
                  By signing up, I agree to the OpenComp&nbsp;
                  <a href="https://www.opencomp.com/terms" className="btn-link">
                    Services Agreement
                  </a>
                  &nbsp;and&nbsp;
                  <a href="https://www.opencomp.com/privacy" className="btn-link">
                    Privacy Notice
                  </a>
                  .
                </div>
              </>
            );
          },
          Footer() {
            const { toSignIn } = useAuthenticator();

            return (
              <div className="footer text-sm text-gray-700">
                Already have an account?&nbsp;
                <a className="cursor-pointer btn-link" onClick={toSignIn}>
                  Log in
                </a>
              </div>
            );
          }
        }
      }}>
      {children}
    </Authenticator>
  );
}

export default CustomAuthenticator;
